import React from "react";
import { FaSpotify, FaYoutube } from "react-icons/fa6";

export const Music = () => {
  return (
    <div className="">
      <div className="text-center text-white">
        <h1 className=" font-bold text-4xl text-srs-pink my-5">Our Music </h1>
        <div className="flex justify-center gap-4">
          <a
            href="https://open.spotify.com/artist/0d1lx35KHn1mbdf3bxhqnm"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaSpotify className="text-white text-5xl hover:scale-110" />
          </a>
          <a
            href="https://www.youtube.com/@SaltRiverShakedown"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaYoutube className="text-white text-5xl hover:scale-110" />
          </a>
        </div>
        <p className="text-xl my-5">
          Click the links above to go to check us out on Spotify, or on our
          Youtube channel
        </p>
        <div className="flex flex-wrap m-3 sm:max-w-7xl sm:m-auto  pb-10 justify-center">
          <div className="m-2 justify-center">
            <div className="bg-srs-pink p-2 rounded-3xl rounded-b-md">
              <h2 className="text-center sm:text-left p-3 rounded-2xl bg-white  w-fit  text-xl text-srs-pink font-semibold">
                The Otherside
              </h2>

            <iframe
              className="YoutubeEmbedLrg mt-3 "
              src="https://www.youtube.com/embed/W6Se2dfJED8"
              title='"The Otherside" - Salt River Shakedown (Official Music Video)'
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen
            ></iframe>
                        </div>

          </div>
          
          <div className="m-2  ">
            <div className="bg-srs-pink p-2 rounded-3xl rounded-b-md">
              <h2 className="text-center sm:text-left p-3 rounded-2xl bg-white  w-fit  text-xl text-srs-pink font-semibold">
                The Lowdown
              </h2>

            <iframe
              className=" YoutubeEmbedLrg mt-3 "
              src="https://www.youtube.com/embed/sSXmGVHXc78"
              title='"The Lowdown" - Salt River Shakedown (OFFICIAL MUSIC VIDEO)'
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen
            ></iframe>
            </div>
          </div>
          <div className="m-2 justify-center">
            <div className="bg-srs-pink p-2 rounded-3xl rounded-b-md">
              <h2 className="text-center sm:text-left p-3 rounded-2xl bg-white  w-fit  text-xl text-srs-pink font-semibold">
                Honey
              </h2>

            <iframe
              className="YoutubeEmbedLrg  mt-3 "
              src="https://www.youtube.com/embed/zANZT1vroNk"
              title='"Honey" - Salt River Shakedown (Official Music Video)'
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen
            ></iframe>
            </div>
          </div>
          <div className="m-2 justify-center">
            <div className="bg-srs-pink p-2 rounded-3xl rounded-b-md">
              <h2 className="text-center sm:text-left p-3 rounded-2xl bg-white  w-fit  text-xl text-srs-pink font-semibold">
                The Lowdown
              </h2>

            <iframe
              className="YoutubeEmbedLrg  mt-3 "
              src="https://www.youtube.com/embed/QSzqaUWb2RA"
              title='"Fight or Flight" - Salt River Shakedown (Official Music Video)'
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen
            ></iframe>
            </div>
          </div>
        </div>
      </div>
      <div>
        <svg
          className=" "
          viewBox="0 0 1440 106"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 28.8459L60 20.5216C120 12.1974 240 -4.4511 360 1.11574C480 6.47447 600 34.5688 720 37.1701C840 39.7715 960 17.9203 1080 12.1974C1200 6.47447 1320 17.9203 1380 23.2791L1440 28.8459V94H1380C1320 94 1200 94 1080 94C960 94 840 94 720 94C600 94 480 94 360 94C240 94 120 94 60 94H0V28.8459Z"
            fill="#FF87B0"
          />
          <path
            d="M0 41.5635L60 33.2393C120 24.915 240 8.26655 360 13.8334C480 19.1921 600 47.2865 720 49.8878C840 52.4891 960 30.638 1080 24.915C1200 19.1921 1320 30.638 1380 35.9967L1440 41.5635V98.5H1380C1320 98.5 1200 98.5 1080 98.5C960 98.5 840 98.5 720 98.5C600 98.5 480 98.5 360 98.5C240 98.5 120 98.5 60 98.5H0V41.5635Z"
            fill="#FFACA3"
          />
          <path
            d="M0 58.6805L60 50.3712C120 42.062 240 25.4434 360 31.0002C480 36.3493 600 64.3932 720 66.9898C840 69.5865 960 47.7746 1080 42.062C1200 36.3493 1320 47.7746 1380 53.1237L1440 58.6805V98.5H1380C1320 98.5 1200 98.5 1080 98.5C960 98.5 840 98.5 720 98.5C600 98.5 480 98.5 360 98.5C240 98.5 120 98.5 60 98.5H0V58.6805Z"
            fill="#8747D1"
          />
          <path
            d="M0 74.2885L60 65.9792C120 57.6699 240 41.0513 360 46.6081C480 51.9572 600 80.0011 720 82.5977C840 85.1944 960 63.3825 1080 57.6699C1200 51.9572 1320 63.3825 1380 68.7316L1440 74.2885V105.5H1380C1320 105.5 1200 105.5 1080 105.5C960 105.5 840 105.5 720 105.5C600 105.5 480 105.5 360 105.5C240 105.5 120 105.5 60 105.5H0V74.2885Z"
            fill="#472A84"
          />
        </svg>
      </div>
    </div>
  );
};
